import { Component, OnInit } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';

declare const angular: angular.IAngularStatic;

@Component({
    selector: 'app-nw-menu-background',
    templateUrl: './background.component.pug',
    styleUrls: ['./background.component.less']
})
export class BackgroundComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}

angular.module('app').directive('app2NwMenuBackground',
    downgradeComponent({ component: BackgroundComponent }));
